module.exports = __webpack_public_path__ + "static/media/magnifying-glass.1289b94e.png";